// @ts-nocheck
<style scoped>

.profile-modal {
  border-radius: 16px 16px 0 0;
}

.modal-content { 
  padding: 20px;
  
 }

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
}

.panel-header span {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--ion-text-color, #2c3e50);
}

.panel-content {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* max-width: 300px;
  margin:0 auto; */

}

.pubkey-display { width: 100%; text-align: center; max-height: 200px; overflow-y: auto; word-break: break-all; }

.pubkey-display p { font-size: 1rem; color: var(--ion-text-color); margin: 0; flex: 1; text-align: left; }

.content-with-copy {
  display: flex;
  align-items: flex-start;
  background: var(--ion-background-color);
  border-radius: 8px;
  padding: 12px;
  border: 1px solid var(--ion-color-light-shade);
}

.copy-icon {
  font-size: 24px;
  color: var(--ion-color-medium);
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 8px;
  opacity: 0.8;
  transition: all 0.2s ease;
}

.copy-icon:hover { color: var(--ion-color-primary); opacity: 1; }

.qr-display { display: flex; justify-content: center; 
padding: 10px;

}

.keypair-display, .reset-password-display {
  width: 100%;
  text-align: center;
  /* max-height: 400px; */
  overflow-y: auto;
  border-radius: 8px;
}

.recovery-btn { margin-bottom: 12px; }

.keypair-btn { --background: var(--ion-color-primary); margin-bottom: 16px; }

.decrypt-btn { --background: var(--ion-color-tertiary); margin-top: 8px; margin-bottom: 12px; }

.keypair-content-wrapper { border-radius: 12px; padding: 16px; margin-top: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); }

.keypair-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px; }

.keypair-warning-box {
  display: flex;
  align-items: center;
  background: rgba(var(--ion-color-danger-rgb), 0.1);
  color: var(--ion-color-danger);
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.keypair-warning-box ion-icon { font-size: 24px; margin-right: 8px; }

.keypair-data { position: relative; margin: 12px 0; width: 100%; }

.keypair-content { background: var(--ion-background-color); padding: 0; text-align: left; font-size: 0.8rem; max-height: 280px; overflow-y: auto; margin: 0; flex: 1; }

.keypair-tip { color: var(--ion-color-medium); font-size: 0.85rem; margin-top: 12px; text-align: left; }

.decrypt-section { margin-top: 16px; padding: 16px; border-radius: 12px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); }

.reset-form { background: var(--ion-background-color); border-radius: 12px; padding: 16px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); }

.custom-item { --background: var(--ion-card-background); --border-radius: 8px; margin-bottom: 16px; }

.reset-btn { margin-top: 8px; --background: var(--ion-color-success); }

.message-box { display: flex; align-items: center; margin-top: 16px; padding: 12px; border-radius: 8px; }

.message-box.success { background: rgba(var(--ion-color-success-rgb), 0.1); color: var(--ion-color-success); }

.message-box.error { background: rgba(var(--ion-color-danger-rgb), 0.1); color: var(--ion-color-danger); }

.message-box ion-icon { font-size: 24px; margin-right: 8px; }

/* 全屏模态窗口样式 */
.fullscreen-modal {
  --height: 100%;
  --width: 100%;
}

.fullscreen-content {
  --background: var(--ion-background-color);
}

.fullscreen-container {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.fullscreen-container h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: var(--ion-color-primary);
}

.fullscreen-container p {
  font-size: 1.2rem;
  margin-bottom: 15px;
  color: var(--ion-text-color);
  opacity: 0.8;
}

.fullscreen-demo-content {
  margin-top: 40px;
  width: 100%;
  max-width: 300px;
}

/* 模态窗口中的DiscoverS组件样式 */
.fullscreen-container DiscoverS,
.fullscreen-container .cosmic-content {
  width: 100% !important;
  height: 100% !important;
}

.fullscreen-container .card-grid {
  display: flex !important;
  flex-direction: column !important;
  gap: 15px !important;
  padding: 10px !important;
  margin-bottom: 20px !important;
  min-height: 200px !important;
}

.fullscreen-container .cosmic-card {
  display: grid !important;
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(0, 255, 213, 0.3) !important;
  border-radius: 12px !important;
  padding: 15px !important;
  min-height: 120px !important;
  width: 100% !important;
  cursor: pointer !important;
  z-index: 10 !important;
  pointer-events: auto !important;
  position: relative !important;
}

.fullscreen-container .cosmic-card:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(0, 255, 213, 0.5) !important;
  transform: translateY(-2px) !important;
}

.fullscreen-container .cosmic-card:active {
  background: rgba(42, 125, 112, 0.3) !important;
  transform: scale(0.98) !important;
}

/* 动态组件容器样式 */
.fullscreen-container > * {
  width: 100%;
  height: 100%;
  position: relative;
}

/* 确保各个页面组件在模态窗口中正确显示 */
.fullscreen-container ion-page {
  display: block !important;
  position: relative !important;
}

.fullscreen-container ion-content {
  --background: transparent !important;
  height: 100% !important;
  position: relative;
}

/* 强制显示DiscoverS组件中的选项列表 */
.fullscreen-container .card-grid {
  display: flex !important;
  flex-direction: column !important;
  gap: 15px !important;
  padding: 10px !important;
  margin-bottom: 20px !important;
  min-height: 200px !important;
  width: 100% !important;
  position: relative !important;
  z-index: 1000 !important;
}

.fullscreen-container .cosmic-card {
  display: grid !important;
  grid-template-rows: auto 1fr !important;
  grid-template-columns: auto 1fr !important;
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 12px !important;
  padding: 15px !important;
  border: 1px solid rgba(0, 255, 213, 0.3) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
  cursor: pointer !important;
  position: relative !important;
  overflow: visible !important;
  min-height: 120px !important;
  width: 100% !important;
  z-index: 1001 !important;
  margin-bottom: 10px !important;
  pointer-events: auto !important;
}

.fullscreen-container .cosmic-card:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(0, 255, 213, 0.5) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0, 255, 213, 0.2) !important;
}

.fullscreen-container .cosmic-card:active {
  background: rgba(42, 125, 112, 0.2) !important;
  transform: scale(0.98) !important;
}

/* 确保图标和标签在模态窗口中正确显示 */
.fullscreen-container .cosmic-icon {
  grid-row: 1 !important;
  grid-column: 1 !important;
  font-size: 32px !important;
  color: rgb(42, 125, 112) !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  z-index: 1 !important;
}

.fullscreen-container .cosmic-label {
  grid-row: 2 !important;
  grid-column: 2 !important;
  font-size: 16px !important;
  color: var(--ion-text-color) !important;
  text-align: right !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  z-index: 1 !important;
  align-self: end !important;
  justify-self: end !important;
  font-weight: 500 !important;
}

/* 模态组件样式 */
.modal-component {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

/* 简洁的淡入缩放过渡效果 */
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

/* 其他复杂动画已简化 */

/* 模态窗口整体动画 */
.fullscreen-modal {
  animation: modalSlideUp 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes modalSlideUp {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 头部导航动画 */
.fullscreen-modal ion-header {
  animation: headerFadeIn 0.5s ease-out 0.2s both;
}


/* 按钮交互动画 */
.fullscreen-modal ion-button {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.fullscreen-modal ion-button:hover {
  transform: scale(1.05);
}

.fullscreen-modal ion-button:active {
  transform: scale(0.95);
}

/* 返回按钮特殊动画 */
.fullscreen-modal ion-buttons[slot="start"] ion-button {
  animation: buttonSlideIn 0.3s ease-out 0.3s both;
}

@keyframes buttonSlideIn {
  0% {
    opacity: 0;
    transform: translateX(-30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 关闭按钮特殊动画 */
.fullscreen-modal ion-buttons[slot="end"] ion-button {
  animation: buttonFadeIn 0.3s ease-out 0.4s both;
}

@keyframes buttonFadeIn {
  0% {
    opacity: 0;
    transform: rotate(90deg) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: rotate(0deg) scale(1);
  }
}

/* 标题动画 */
.fullscreen-modal ion-title {
  animation: titleSlideIn 0.4s ease-out 0.25s both;
}

@keyframes titleSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 新增 user-details 样式 */
.user-details {
  display: flex;
  flex-direction: column;
  align-items: start; 
  justify-content: start;
  text-align: center;
}

/* 内容区域样式优化 */
.profile-content {
  --background: transparent;
}

.profile-content::part(scroll) {
  padding: 0;
  margin: 0;
}

.canvas-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
 
}

.user-info-overlay {
  position: absolute;
  top: 15%;
  left: 10px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.2);
  padding: 6px;
  border-radius: 12px;
  backdrop-filter: blur(5px);
}

.avatar-wrapper {
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin-left: 10px;
}

.avatar {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
  cursor: pointer;
  user-select: none;
  position: relative;
  z-index: 2;
  border: 2px solid rgba(255, 255, 255, 0.5);
}

.avatar-glow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  filter: blur(10px);
  transform: scale(1.1);
  opacity: 0.6;
  z-index: 1;
  pointer-events: none;
}

.user-text-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
}

.username {
  font-weight: bold;
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  font-size: 1.1rem; /* smaller */
  margin: 0;
  color: var(--ion-text-color);
  text-shadow: 1px 1px 3px rgba(0,0,0,0.5);
}

.signature-text {
  font-size: 0.7rem !important; /* smaller */
  font-weight: 500;
  color: rgba(145, 145, 145, 0.703);
}

/* For RadiantText */
.user-info-overlay .inline-flex {
  padding: 0 !important;
}

.controls-overlay {
  position: absolute;
  top: 15%;
  right: 10px;
  z-index: 10;

 
 
  gap: 8px;
}

/* 分层动画关键帧已移除 */
ion-header {
  z-index: 1000;
}

.top-toolbar ion-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}



ion-icon {
  font-size: 24px;
  color: var(--ion-text-color);
}

/* 3D网络Canvas样式 */
.network-canvas {
  width: 100% !important;
  height: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  cursor: grab;
}

.network-canvas:active {
  cursor: grabbing;
}

.stranger-relay-modal .relay-item {
  --padding-start: 16px;
  --padding-end: 16px;
  border-bottom: 1px solid var(--ion-border-color, rgba(0,0,0,0.1));
}

.stranger-relay-modal .relay-url {
  font-family: monospace;
  font-size: 0.9em;
}

.stranger-relay-modal ion-button {
  --padding-start: 8px;
  --padding-end: 8px;
}

/* 地球canvas样式 */
/* .globe-canvas {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 90vw;
  max-width: 500px;
  max-height: 500px;
  z-index: 2;
  pointer-events: auto;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  background: transparent;
} */

.legend-panel {
  position: absolute;
  top: unset;
  right: 10px;
  margin-top: 8px;
  z-index: 10;
  background: rgba(20, 20, 20, 0.8);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 12px;
  color: white;
  width: 200px;
}

.legend-title {
  font-weight: bold;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 4px;
}

.legend-panel ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.legend-panel li {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  font-size: 0.9em;
}

.legend-panel li:last-child {
  margin-bottom: 0;
}

.legend-color-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.canvas-buttons {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;
  display: flex;
  gap: 8px;
}

.legend-button, .stranger-list-button, .refresh-canvas-button {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 8px;
  --padding-bottom: 8px;
  height: 36px;
  width: 36px;
  margin-right: 10px;
}

.legend-button ion-icon, .stranger-list-button ion-icon {
  font-size: 24px;
}

.friend-label {
  color: white; /* 默认白色文字 */
  font-size: 0.7em; /* 字体大小 */
  font-weight: bold;
  background: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  padding: 3px 6px;
  border-radius: 4px;
  pointer-events: none; /* 确保不影响鼠标事件 */
  white-space: nowrap; /* 防止换行 */
  transform: translateY(-100%); /* 向上偏移，使其位于球体上方 */
}

.user-label, .relay-label {
  color: white;
  font-size: 0.65em;
  font-weight: bold;
  background: rgba(0, 0, 0, 0.5);
  padding: 2px 5px;
  border-radius: 3px;
  pointer-events: none;
  white-space: nowrap;
  transform: translateY(-100%);
}

html.dark .friend-label, html.dark .user-label, html.dark .relay-label {
  color: #eee;
  background: rgba(255, 255, 255, 0.2);
}

html.light .friend-label, html.light .user-label, html.light .relay-label {
  color: #333;
  background: rgba(0, 0, 0, 0.2);
}
</style>
<template>
  <div class="canvas-container">
    <!-- 3D网络拓扑图 -->
    <canvas ref="networkCanvasRef" class="network-canvas"></canvas>
  </div>
  <!-- 顶部栏 -->
  <ion-header :translucent="true"  class="ion-no-border ">
    <ion-toolbar >
      <!-- 左侧按钮组 -->
      <ion-buttons slot="start">
        <ion-button fill="clear" @click="gotoSettings">
          <ion-icon :icon="settingsOutline"></ion-icon>
        </ion-button>
       
        <ion-button fill="clear" @click="goToRelay">
          <ion-icon :icon="rocketOutline"></ion-icon>
        </ion-button>
        <ion-button fill="clear" @click="goToAiSetting">
          <ion-icon :icon="happyOutline"></ion-icon>
        </ion-button>
      
        <!-- <ion-button fill="clear" @click="openFullscreenModal">
          <ion-icon :icon="appsOutline"></ion-icon>
        </ion-button> -->
      </ion-buttons>
      
      <!-- 右侧按钮组 -->
      <ion-buttons slot="end">
        <!-- <ion-button fill="clear" @click="goToGunStatus">
          <ion-icon :icon="serverOutline"></ion-icon>
        </ion-button> -->
        <ion-button fill="clear" @click="openFullscreenModal">
          <ion-icon :icon="appsOutline"></ion-icon>
        </ion-button>
        <ion-button fill="clear" @click="showPanel('qrcode')">
          <ion-icon :icon="qrCodeOutline"></ion-icon>
        </ion-button>
        <ion-button fill="clear" @click="goToScan">
          <ion-icon :icon="scanSharp"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <ion-toolbar style="--background: transparent; gap:8px;" >
      <!-- 左侧按钮组 -->
      <ion-buttons slot="start">
         <div class="avatar-wrapper" @click="gotomyset">
      
          <img
            v-if="userAvatars[currentUserPub!]"
            :src="userAvatars[currentUserPub!]"
            alt=""
            class="avatar"
            :style="avatarStyle"
          />
          <img
            v-else
            :src="avatarurl"
            class="avatar"
            
          /> 
        </div>
        
        <div class="user-text-info">
          <h1 class="username">{{ currentUserAlias || 'No Name' }}</h1>
          <RadiantText
            class="inline-flex items-center justify-center transition ease-out hover:text-neutral-600 hover:duration-300 hover:dark:text-neutral-400"
          >
            <span class="signature-text">{{ currentUserAlias1 || '' }}</span>
          </RadiantText>
        </div>
      </ion-buttons>
      
      <!-- 右侧按钮组 -->
      <ion-buttons slot="end">

        <ion-button class="refresh-canvas-button" fill="clear" @click="refreshCanvas">
          <ion-icon :icon="refreshOutline"></ion-icon>
        </ion-button>
        <ion-button class="legend-button" fill="clear" @click="toggleLegend">
          <ion-icon :icon="helpCircleOutline"></ion-icon>
        </ion-button>
        <ion-button class="stranger-list-button" fill="clear" @click="openStrangerRelayModal">
          <ion-icon :icon="cloudDownloadOutline"></ion-icon>
        </ion-button>

      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <div v-if="isLegendVisible" class="legend-panel">
          <div class="legend-title">{{ $t('legendTitle') }}</div>
          <ul>
            <li v-for="item in legendItems" :key="item.label">
              <span class="legend-color-dot" :style="{ backgroundColor: item.color }"></span>
              {{ $t(item.label) }}
            </li>
          </ul>
        </div>
  
  <!-- 内容区域 -->
  <ion-content :fullscreen="true" :scroll-y="false" class="profile-content">
    
  </ion-content>

  <ion-modal
    :is-open="panelVisible"
    css-class="profile-modal"
    :breakpoints="[0, 0.5, 1]"
    :initial-breakpoint="0.8"
    @didDismiss="hidePanel"
  >
    <ion-content class="modal-content">
      <div class="panel-header">
        <span>{{ panelContent === 'pubkey' ? '' : panelContent === 'qrcode' ? '' : panelContent === 'keypair' ? 'Key Pair' : 'Reset Password' }}</span>
        <ion-icon
          color="dark"
          :icon="closeCircleSharp"
          style="font-size: 29px;"
          @click="hidePanel"
        ></ion-icon>
      </div>

      <div class="panel-content">
        <div v-if="panelContent === 'qrcode'">
          <div class="qr-display">
            <QrShow :data="'pubkey:' + currentUserPub" />
          </div>

          <div class="content-with-copy pubkey-display">
            <p>PubKey: {{ currentUserPub }}</p>
            <ion-icon
              :icon="copyOutline"
              class="copy-icon"
              @click="copyPub(currentUserPub)"
            ></ion-icon>
          </div>
          
          <div v-if="showKeyPair" class="keypair-content-wrapper">
            <div v-if="!encryptedPair" class="keypair-loading">
              <ion-spinner name="dots"></ion-spinner>
              <p>Loading key pair...</p>
            </div>
            <template v-else>
              <div class="keypair-data">
                <div class="content-with-copy">
                  <pre class="keypair-content">{{ encryptedPair }}</pre>
                  <ion-icon
                    :icon="copyOutline"
                    class="copy-icon"
                    @click="copyEncryptedKeyPair"
                  ></ion-icon>
                </div>
              </div>
              <div class="keypair-warning-box">
                <ion-icon :icon="warningOutline"></ion-icon>
                <p>This is your encrypted key pair. Keep it safe!</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-modal>

      <!-- 全屏模态窗口 -->
      <ion-modal
        :is-open="fullscreenModalVisible"
        css-class="fullscreen-modal"
        @didDismiss="closeFullscreenModal"
      >
        <ion-header>
          <ion-toolbar>
            <ion-buttons slot="start" v-if="canGoBack">
              <ion-button @click="goBackInModal">
                <ion-icon :icon="arrowBackOutline"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-title>{{ getModalTitle() }}</ion-title>
            <ion-buttons slot="end">
              <ion-button @click="closeFullscreenModal">
                <ion-icon :icon="closeCircleSharp"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        
        <ion-content class="fullscreen-content" :scroll-y="true">
          <div class="fullscreen-container">
            

      
            <Transition 
              name="fade-scale" 
              mode="out-in"
            >
              <component 
                :is="currentModalComponentRef"
                :key="currentModalComponent"
                :modalNavigation="provideModalNavigation()"
                class="modal-component"
              />
            </Transition>

          </div>
        </ion-content>
      </ion-modal>

      <!-- 新增：陌生节点模态窗口 -->
      <ion-modal
        :is-open="isStrangerRelayModalOpen"
        css-class="stranger-relay-modal"
        @didDismiss="isStrangerRelayModalOpen = false"
      >
        <ion-header>
          <ion-toolbar>
            <ion-title>{{ $t('strangerRelaysTitle') }}</ion-title>
            <ion-buttons slot="end">
              <ion-button @click="isStrangerRelayModalOpen = false">
                <ion-icon :icon="closeCircleSharp"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content>
          <ion-list>
            <ion-item v-for="url in strangerRelaysList" :key="url" class="relay-item">
              <ion-label class="relay-url">{{ url }}</ion-label>
              <ion-button slot="end" fill="clear" @click="handleAddStrangerRelay(url)">
                <ion-icon :icon="addCircleOutline"></ion-icon>
              </ion-button>
            </ion-item>
          </ion-list>
        </ion-content>
      </ion-modal>

      
</template>

<script lang="ts" setup>
import { cn } from "@/lib/utils";
import { useSpring } from "vue-use-spring";
import { ref, shallowRef, onMounted, onUnmounted, watch, computed } from 'vue';
import { useTheme } from '@/composables/useTheme';

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { Raycaster, Vector2 } from 'three';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import { useI18n } from 'vue-i18n';
import { useNetworkStatus } from '@/composables/useNetworkStatus';

// Other imports remain unchanged
import Chat from './ChatS.vue';
import Contacts from './ContactsS.vue';
import DiscoverS from './DiscoverS.vue';
import Profile from './MeS.vue';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { chatbubblesOutline, chatbubbleOutline, peopleOutline, personOutline, planetOutline, settingsOutline, rocketOutline, browsersOutline, atOutline, sparklesOutline, chatbubbleEllipsesOutline, compassOutline, walletOutline, reorderFourOutline, reorderThreeOutline, appsOutline, serverOutline, addCircleOutline, helpCircleOutline, cloudDownloadOutline, happyOutline, refreshOutline } from 'ionicons/icons';
import { IonFooter, IonToolbar, IonContent, IonIcon, IonHeader, IonMenu, IonSplitPane, IonTitle } from '@ionic/vue';
import { gunAvatar } from "gun-avatar";
import ChatSpad from '../ipad/ChatSpad.vue';
import RelayMode from '../GUNtest/RelayMode.vue';
import { useRouter } from 'vue-router';
import { IonModal, IonItem, IonLabel, IonInput, IonButton, IonSpinner, IonButtons } from '@ionic/vue';
import { closeCircleSharp, copyOutline, keyOutline, qrCodeOutline, keySharp, lockClosedOutline, eyeOutline, eyeOffOutline, refreshCircleOutline, warningOutline, lockOpenOutline, checkmarkCircleOutline, alertCircleOutline, scanSharp, menuOutline, expandOutline, arrowBackOutline } from 'ionicons/icons';
import { getTalkFlowCore } from '@/composables/TalkFlowCore';

import RadiantText from '../ui/radiant-text/RadiantText.vue';

// 导入模态窗口需要的页面组件
import QrPage from '../../pages/qrpage.vue';
import HtmlPage from '../../pages/htmlpage.vue';
import RelayPage from '../GUNtest/RelayMode.vue';
import Browser from '../../pages/browser.vue';
import AiSetting from '../../pages/AiSetting.vue';
import AiChat from '../../pages/AiChat.vue';
import ScanPage from '../../pages/ScanPage.vue';

const { isDark } = useTheme();
const chatFlowStore = getTalkFlowCore();
const router = useRouter();
const { t } = useI18n();
// @ts-ignore
const {
  copyPub, currentUserPub, currentUserAlias, currentUserAlias1, userAvatars, storageServ, gun, isDragging, startY, translateY, cardsTranslateY, velocity, lastTouchTime, lastTouchY, panelVisible: _panelVisible, panelContent: _panelContent, encryptData, decryptData, showToast, isLargeScreen, updateScreenSize, currentComponent, previousComponent, switchTo,
  fullscreenModalVisible,
  buddyList, // 新增：获取好友列表
} = chatFlowStore;

// 直接调用 useNetworkStatus 获取最新的网络状态
const { peersList, peerStatuses, addPeer } = useNetworkStatus(storageServ);

const avatarurl = computed(() => gunAvatar({ pub: currentUserPub.value, round: false, dark: isDark.value, svg: true }));

// 新增：好友和共享节点的状态
const friendsRelays = ref<Record<string, string[]>>({});
const friendListeners: Record<string, any> = {};

// 新增：陌生节点模态窗口状态
const isStrangerRelayModalOpen = ref(false);
const strangerRelaysList = ref<string[]>([]);

// 新增：图例状态
const isLegendVisible = ref(false);
const legendItems = ref([
  { color: '#9370DB', label: 'legendYou' },
  { color: '#00BFFF', label: 'legendFriend' },
  { color: '#00FF00', label: 'legendConnectedRelay' },
  { color: '#808080', label: 'legendDisabledRelay' },
  { color: '#FF0000', label: 'legendErrorRelay' },
  { color: '#FFFF00', label: 'legendStrangerRelay' },
]);

const toggleLegend = () => {
  isLegendVisible.value = !isLegendVisible.value;
};

function goToGunStatus() { router.push('/GunStatus'); }
function goToAiSetting() { router.push('/AiSet'); }

// Other existing variables and functions remain unchanged
type PanelContentType = 'pubkey' | 'qrcode' | 'keypair' | 'resetpassword' | null;
const localPanelContent = ref<PanelContentType>(null);
const localPanelVisible = ref(false);

const panelVisible = computed({
  get: () => localPanelVisible.value,
  set: (value) => { localPanelVisible.value = value; _panelVisible.value = value; }
});

const panelContent = computed({
  get: () => localPanelContent.value,
  set: (value) => {
    localPanelContent.value = value;
    if (value === 'pubkey' || value === 'qrcode' || value === null) {
      _panelContent.value = value as 'pubkey' | 'qrcode' | null;
    }
  }
});

function goToScan() { router.push('/ScanPage'); }
function goToRelay() { router.push('/relaypage'); }
function gotoSettings() { router.push('/settingspage'); }
function gotoDiscover() { router.push('/discoverpage'); }
function gotomyset() { router.push('/myself'); }

// 全屏模态窗口函数
async function openFullscreenModal() {
  fullscreenModalVisible.value = true;
  
  // 尝试加载上次保存的状态
  if (currentUserPub.value) {
    try {
      const savedState = await storageServ.getModalState(currentUserPub.value);
      if (savedState && savedState.component && savedState.history.length > 0) {
        // 恢复上次的状态
        currentModalComponent.value = savedState.component;
        modalComponentHistory.value = [...savedState.history];
        
      } else {
        // 使用默认状态
        currentModalComponent.value = 'DiscoverS';
        modalComponentHistory.value = ['DiscoverS'];
      }
    } catch (error) {
      
      currentModalComponent.value = 'DiscoverS';
      modalComponentHistory.value = ['DiscoverS'];
    }
  } else {
    // 没有用户信息时使用默认状态
    currentModalComponent.value = 'DiscoverS';
    modalComponentHistory.value = ['DiscoverS'];
  }
}

async function closeFullscreenModal() {
  // 保存最终状态
  await saveModalState();
  
  fullscreenModalVisible.value = false;
}

// 保存模态窗口状态到数据库
async function saveModalState() {
  if (currentUserPub.value) {
    try {
      await storageServ.saveModalState(
        currentUserPub.value,
        currentModalComponent.value,
        modalComponentHistory.value
      );
      
    } catch (error) {
      
    }
  }
}

// 组件内导航函数
async function navigateToModalComponent(componentName: string) {
  if (currentModalComponent.value !== componentName) {
    modalComponentHistory.value.push(componentName);
    currentModalComponent.value = componentName;
    
    // 保存状态到数据库
    await saveModalState();
  }
}

async function goBackInModal() {
  if (modalComponentHistory.value.length > 1) {
    modalComponentHistory.value.pop();
    currentModalComponent.value = modalComponentHistory.value[modalComponentHistory.value.length - 1];
    
    // 保存状态到数据库
    await saveModalState();
  }
}



// 检查是否可以返回
const canGoBack = computed(() => modalComponentHistory.value.length > 1);

// 为全局访问提供导航函数
function provideModalNavigation() {
  return {
    navigateToModalComponent: async (componentName: string) => {
      await navigateToModalComponent(componentName);
    },
    goBackInModal: async () => {
      await goBackInModal();
    },
    canGoBack: canGoBack.value
  };
}

// 获取模态窗口标题
function getModalTitle() {
  const titleMap: Record<string, string> = {
    DiscoverS: t('GunOS'),
    QrPage: t('qrcodetool'),
    HtmlPage: t('offlinewebtools'),
    RelayPage: t('relaySettings'),
    Browser: t('Browser'),
    AiSetting: t('aiSettings'),
    AiChat: t('aiChat'),
    ScanPage: t('scanner')
  };
  return titleMap[currentModalComponent.value] || t('GunOS');
}
const midPoint = 0;

const positionState = ref('middle');
const encryptedPair = ref('');
const showKeyPair = ref(false);
const avatarStyle = ref({});
const decryptPassphrase = ref('');
const decryptMessage = ref('');
const showDecryptedKeyPair = ref(false);
const decryptedPair = ref('');

// 组件内路由状态
const currentModalComponent = ref('DiscoverS');
const modalComponentHistory = ref(['DiscoverS']);

// 组件映射
const modalComponents = {
  DiscoverS,
  QrPage,
  HtmlPage,
  RelayPage,
  Browser,
  AiSetting,
  AiChat,
  ScanPage,
};

// 获取当前模态组件
const currentModalComponentRef = computed(() => {
  return modalComponents[currentModalComponent.value as keyof typeof modalComponents] || DiscoverS;
});

// three.js 相关的引用和状态
const networkCanvasRef = ref<HTMLCanvasElement | null>(null);
let renderer: THREE.WebGLRenderer | null = null;
let labelRenderer: CSS2DRenderer | null = null; // Declare labelRenderer
let scene: THREE.Scene | null = null;
let camera: THREE.PerspectiveCamera | null = null;
let controls: OrbitControls | null = null;
let animationFrameId: number;
const networkGroup = new THREE.Group(); // 用于容纳所有球体和线条
let intervalId: ReturnType<typeof setInterval> | undefined;


// 刷新Canvas
const refreshCanvas = () => {
  cleanupThreeScene();
  // 使用一个短暂的延迟确保资源完全释放
  setTimeout(() => {
    initThreeScene();
    // 可以在这里向用户显示一个提示
    showToast(t('canvasRefreshed', 'Canvas Refreshed'), 'success');
  }, 100);
};

// 初始化 Three.js 场景
const initThreeScene = () => {
  if (!networkCanvasRef.value) return;

  // 1. 渲染器
  renderer = new THREE.WebGLRenderer({
    canvas: networkCanvasRef.value,
    antialias: true,
    alpha: true,
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(networkCanvasRef.value.clientWidth, networkCanvasRef.value.clientHeight);

  // 初始化 CSS2DRenderer (for labels)
  labelRenderer = new CSS2DRenderer();
  labelRenderer.setSize(networkCanvasRef.value.clientWidth, networkCanvasRef.value.clientHeight);
  labelRenderer.domElement.style.position = 'absolute';
  labelRenderer.domElement.style.top = '0px';
  labelRenderer.domElement.style.pointerEvents = 'none'; // Allow clicking through labels to canvas
  networkCanvasRef.value.parentNode!.appendChild(labelRenderer.domElement);

  // 2. 场景
  scene = new THREE.Scene();
  scene.add(networkGroup);

  // 3. 相机
  camera = new THREE.PerspectiveCamera(
    50,
    networkCanvasRef.value.clientWidth / networkCanvasRef.value.clientHeight,
    0.1,
    1000
  );
  camera.position.z = 25;
  camera.position.y = 4; // 将相机向上移动，使场景在可视区域内居中
 
  

  // 4. 光源
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
  scene.add(ambientLight);
  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
  directionalLight.position.set(5, 5, 5);
  scene.add(directionalLight);
  
  // 5. 控制器
  controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.screenSpacePanning = false;
  controls.minDistance = 5;
  controls.maxDistance = 50;

  // 6. 创建网络图
  createNetworkGraph();

  // 7. 动画循环
  animate();

  // 8. 响应式处理
  window.addEventListener('resize', onWindowResize);

  // 9. 点击事件监听
  networkCanvasRef.value.addEventListener('click', onCanvasClick);
  
  // 10. 定期刷新网络状态 - 移除此行以避免自动刷新
  if (intervalId) clearInterval(intervalId);
  // intervalId = setInterval(createNetworkGraph, 10000); // 移除或注释掉这行
};

// 创建网络图
const createNetworkGraph = () => {
  console.log('--- createNetworkGraph started ---');
  if (!currentUserPub.value) {
    console.log('createNetworkGraph: currentUserPub not available.');
    return;
  }

  // 清理旧对象
  networkGroup.clear();
  
  // --- 节点数据收集 ---
  const allRelays = new Map<string, { sharedBy: Set<string> }>();
  
  // 1. 添加自己的节点
  console.log('Processing current user\'s peersList:', peersList.value);
  peersList.value.forEach(url => {
    if (!allRelays.has(url)) allRelays.set(url, { sharedBy: new Set() });
    allRelays.get(url)!.sharedBy.add(currentUserPub.value!); // Mark as shared by current user
  });

  // 2. 添加好友共享的节点
  console.log('Processing friendsRelays:', JSON.parse(JSON.stringify(friendsRelays.value)));
  for (const friendPub in friendsRelays.value) {
    const relays = friendsRelays.value[friendPub];
    if (relays && Array.isArray(relays)) {
      relays.forEach(url => {
        if (!allRelays.has(url)) allRelays.set(url, { sharedBy: new Set() });
        allRelays.get(url)!.sharedBy.add(friendPub); // Mark as shared by friend
      });
    }
  }
  console.log('allRelays after processing all:', JSON.parse(JSON.stringify(Array.from(allRelays.entries()))));

  // --- 3D对象创建 ---
  const nodeMeshes = new Map<string, THREE.Mesh>();
  const radius = 5;
  let relayIndex = 0;

  // 1. 创建用户球体
  const userSphere = createSphere(0.5, 0x9370DB); // 紫色
  userSphere.position.set(0, 0, 0);
  networkGroup.add(userSphere);
  nodeMeshes.set(currentUserPub.value, userSphere);
  console.log('User sphere created.');

  // Create CSS2DObject for user's alias
  const userLabelDiv = document.createElement('div');
  userLabelDiv.className = 'user-label';
  userLabelDiv.textContent = currentUserAlias.value || 'You';
  const userLabel = new CSS2DObject(userLabelDiv);
  userLabel.position.set(0, 0.6, 0); // Position slightly above the user sphere
  networkGroup.add(userLabel);

  // 2. 创建好友球体
  const friendPubs = Object.keys(friendsRelays.value);
  console.log('Creating friend spheres for:', friendPubs);
  friendPubs.forEach((pub, index) => {
    const friendSphere = createSphere(0.4, 0x00BFFF); // 蓝色

    // Generate random positions within a spherical volume around the user sphere
    const minDistance = 2.0; // Minimum distance from the user sphere
    const maxDistance = 4.0; // Maximum distance from the user sphere

    let x, y, z, distance;
    do {
      x = (Math.random() - 0.5) * (maxDistance * 2); // -maxDistance to +maxDistance
      y = (Math.random() - 0.5) * (maxDistance * 2);
      z = (Math.random() - 0.5) * (maxDistance * 2);
      distance = Math.sqrt(x * x + y * y + z * z);
    } while (distance < minDistance || distance > maxDistance); // Ensure within the desired annular spherical volume

    friendSphere.position.set(x, y, z);
    networkGroup.add(friendSphere);
    nodeMeshes.set(pub, friendSphere);
    console.log(`Friend sphere created for ${pub.slice(0, 8)} at (${x.toFixed(2)}, ${y.toFixed(2)}, ${z.toFixed(2)})`);

    // Create CSS2DObject for friend's alias
    const friendAlias = buddyList.value.find(b => b.pub === pub)?.alias || `Friend ${pub.slice(0, 8)}`;
    const friendLabelDiv = document.createElement('div');
    friendLabelDiv.className = 'friend-label';
    friendLabelDiv.textContent = friendAlias;
    const friendLabel = new CSS2DObject(friendLabelDiv);
    friendLabel.position.set(x, y + 0.6, z); // Position slightly above the sphere
    networkGroup.add(friendLabel);
  });
  
  // 3. 创建中继节点球体
  console.log('Creating relay spheres.');
  Array.from(allRelays.keys()).forEach(url => {
    const isUserRelay = allRelays.get(url)!.sharedBy.has(currentUserPub.value!); // If shared by current user
    const isFriendShared = Array.from(allRelays.get(url)!.sharedBy).some(pub => pub !== currentUserPub.value); // If shared by any friend
    let statusColor = 0xFFFF00; // Yellow: Stranger relay (default)

    if (isUserRelay) {
      const status = peerStatuses.value[url];
      if (status === 'connected') statusColor = 0x00FF00; // Green
      else if (status === 'disconnected') statusColor = 0xFF0000; // Red
      else statusColor = 0x808080; // Gray
      console.log(`Relay ${url} is user's relay. Status: ${status}, Color: ${statusColor.toString(16)}`);
    } else if (isFriendShared) {
      statusColor = 0xFFFF00; // Yellow for friend-shared relays which are stranger to current user
      console.log(`Relay ${url} is friend-shared and stranger to user. Color: ${statusColor.toString(16)}`);
    } else {
      console.log(`Relay ${url} is neither user's nor friend-shared. Defaulting to yellow (stranger).`);
    }

    const relaySphere = createSphere(0.3, statusColor);
    relaySphere.userData.url = url; // Store URL for click interaction
    relaySphere.userData.isStranger = !isUserRelay; // isStranger means not my own relay

    // Introduce randomness for relay positioning
    const phi = Math.acos(-1 + (2 * relayIndex) / (allRelays.size > 1 ? allRelays.size - 1 : 1));
    const theta = Math.sqrt(allRelays.size * Math.PI) * phi;

    const phiJitter = (Math.random() - 0.5) * 0.3; // -0.15 to 0.15 radians
    const thetaJitter = (Math.random() - 0.5) * 0.3; // -0.15 to 0.15 radians

    const minRelayRadius = 4.0;
    const maxRelayRadius = 6.0;
    const currentRelayRadius = minRelayRadius + Math.random() * (maxRelayRadius - minRelayRadius);

    const yPositionRelay = (Math.random() - 0.5) * 2.0; // -1.0 to 1.0

    relaySphere.position.set(
      currentRelayRadius * Math.cos(theta + thetaJitter) * Math.sin(phi + phiJitter),
      currentRelayRadius * Math.sin(theta + thetaJitter) * Math.sin(phi + phiJitter) + yPositionRelay,
      currentRelayRadius * Math.cos(phi + phiJitter)
    );

    networkGroup.add(relaySphere);
    nodeMeshes.set(url, relaySphere);
    relayIndex++;
    console.log(`Relay sphere created for ${url}. isStranger: ${relaySphere.userData.isStranger}`);

    // Create CSS2DObject for relay URL
    const relayLabelDiv = document.createElement('div');
    relayLabelDiv.className = 'relay-label';
    relayLabelDiv.textContent = url.replace(/^(https?:\/\/|wss:\/\/)/, '').replace(/\/gun$/, ''); // Clean up URL for display
    const relayLabel = new CSS2DObject(relayLabelDiv);
    relayLabel.position.set(
      relaySphere.position.x,
      relaySphere.position.y + 0.4, // Position slightly above the sphere
      relaySphere.position.z
    );
    networkGroup.add(relayLabel);
  });

  // --- 连接线创建 ---
  console.log('Creating connection lines.');
  allRelays.forEach((data, url) => {
    const relayMesh = nodeMeshes.get(url);
    if (!relayMesh) {
      console.warn(`Relay mesh not found for URL: ${url}`);
      return;
    }

    data.sharedBy.forEach(pub => {
      const userOrFriendMesh = nodeMeshes.get(pub);
      if (userOrFriendMesh) {
        const line = createLine(userOrFriendMesh.position, relayMesh.position);
        networkGroup.add(line);
        console.log(`Line created from ${pub.slice(0, 8)} to ${url}`);
      } else {
        console.warn(`User/Friend mesh not found for Pub: ${pub}`);
      }
    });
  });
  console.log('--- createNetworkGraph finished ---');
};

// 辅助函数：创建球体
const createSphere = (radius: number, color: number): THREE.Mesh => {
  const geometry = new THREE.SphereGeometry(radius, 32, 32);
  const material = new THREE.MeshStandardMaterial({ color, roughness: 0.5 });
  return new THREE.Mesh(geometry, material);
};

// 辅助函数：创建线条
const createLine = (start: THREE.Vector3, end: THREE.Vector3): THREE.Line => {
  const points = [start, end];
  const geometry = new THREE.BufferGeometry().setFromPoints(points);
  const material = new THREE.LineBasicMaterial({ color: 0xaaaaaa, transparent: true, opacity: 0.3 });
  return new THREE.Line(geometry, material);
};


// 点击事件处理
const onCanvasClick = (event: MouseEvent) => {
  if (!networkCanvasRef.value || !camera) return;

  const raycaster = new Raycaster();
  const mouse = new Vector2();
  
  // 将鼠标点击位置转换为标准化设备坐标
  const rect = networkCanvasRef.value.getBoundingClientRect();
  mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
  mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
  
  raycaster.setFromCamera(mouse, camera);
  
  const intersects = raycaster.intersectObjects(networkGroup.children);
  
  if (intersects.length > 0) {
    const firstIntersected = intersects[0].object as THREE.Mesh;
    if (firstIntersected.userData.isStranger && firstIntersected.userData.url) {
      // Just show toast on click, modal is opened by button now
      showToast(t('relayToast', { url: firstIntersected.userData.url }), 'info');
    }
  }
};

// 新增：打开陌生节点模态窗口的独立函数
const openStrangerRelayModal = () => {
  strangerRelaysList.value = [];
  networkGroup.children.forEach(child => {
    const mesh = child as THREE.Mesh;
    if (mesh.userData.isStranger && mesh.userData.url) {
      if (!strangerRelaysList.value.includes(mesh.userData.url)) {
        strangerRelaysList.value.push(mesh.userData.url);
      }
    }
  });

  if (strangerRelaysList.value.length >= 0) {
    isStrangerRelayModalOpen.value = true;
  } else {
    showToast(t('noStrangerRelays'), 'info');
  }
};

// 新增：处理添加陌生节点逻辑
const handleAddStrangerRelay = (url: string) => {
  addPeer(url);
  showToast(t('relayAddedRestart'), 'success');
  // 从列表中移除，提供即时反馈
  strangerRelaysList.value = strangerRelaysList.value.filter(item => item !== url);
  if(strangerRelaysList.value.length === 0){
    isStrangerRelayModalOpen.value = false;
  }
};

// 动画循环
const animate = () => {
  animationFrameId = requestAnimationFrame(animate);
  
  // 缓慢自转
  networkGroup.rotation.y += 0.001;

  controls?.update();
  renderer?.render(scene!, camera!);
  labelRenderer?.render(scene!, camera!); // Render labels
};

// 窗口大小调整
const onWindowResize = () => {
  if (camera && renderer && networkCanvasRef.value) {
    camera.aspect = networkCanvasRef.value.clientWidth / networkCanvasRef.value.clientHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(networkCanvasRef.value.clientWidth, networkCanvasRef.value.clientHeight);
    labelRenderer?.setSize(networkCanvasRef.value.clientWidth, networkCanvasRef.value.clientHeight); // Resize label renderer
  }
};

const cleanupThreeScene = () => {
  if (intervalId) clearInterval(intervalId);
  if (animationFrameId) cancelAnimationFrame(animationFrameId);
  
  window.removeEventListener('resize', onWindowResize);
  networkCanvasRef.value?.removeEventListener('click', onCanvasClick);
  
  controls?.dispose();
  renderer?.dispose();
  // Remove labelRenderer's DOM element from its parent
  if (labelRenderer && networkCanvasRef.value?.parentNode) {
    networkCanvasRef.value.parentNode.removeChild(labelRenderer.domElement);
  }
  
  renderer = null;
  scene = null;
  camera = null;
  controls = null;
  labelRenderer = null; // Reset label renderer
}

// 监听好友列表和共享状态
const setupFriendListeners = () => {
  console.log('--- setupFriendListeners started ---');
  if (!gun || !buddyList.value) {
    console.log('setupFriendListeners: Gun or buddyList not available.');
    return;
  }
  console.log('Current buddyList:', buddyList.value.map(b => b.pub.slice(0, 8)));

  // 清理旧的监听器
  Object.values(friendListeners).forEach(off => off());
  // Clear old friendsRelays data (IMPORTANT!)
  friendsRelays.value = {}; 

  buddyList.value.forEach(buddy => {
    // Ensure every buddy has an entry, even if no shared relays yet
    if (!friendsRelays.value[buddy.pub]) {
      friendsRelays.value[buddy.pub] = []; 
    }

    const path = gun.get('users').get(buddy.pub).get('sharedRelays');
    friendListeners[buddy.pub] = path.on(data => {
      try {
        console.log(`Received sharedRelays for buddy ${buddy.pub.slice(0, 8)}:`, data);
        if (data) {
          const parsedRelays = JSON.parse(data);
          if (Array.isArray(parsedRelays)) {
            friendsRelays.value[buddy.pub] = parsedRelays;
          } else {
            friendsRelays.value[buddy.pub] = []; 
          }
        } else {
          friendsRelays.value[buddy.pub] = []; 
        }
      } catch (e) {
        console.error(`Error parsing sharedRelays for buddy ${buddy.pub.slice(0, 8)}:`, e);
        friendsRelays.value[buddy.pub] = []; 
      }
      console.log('friendsRelays after update:', JSON.parse(JSON.stringify(friendsRelays.value))); // Deep copy for logging
      createNetworkGraph(); // 数据变化时重绘
    });
  });
  console.log('Initial friendsRelays after setup:', JSON.parse(JSON.stringify(friendsRelays.value)));
  createNetworkGraph(); 
  console.log('--- setupFriendListeners finished ---');
};

watch(buddyList, setupFriendListeners, { deep: true, immediate: true });
watch([peersList, peerStatuses, friendsRelays], createNetworkGraph, { deep: true });


// 组件挂载和卸载
onMounted(() => {
  // 延迟初始化以确保canvas渲染完毕
  setTimeout(initThreeScene, 300);
});

onUnmounted(() => {
  cleanupThreeScene();
  Object.values(friendListeners).forEach(off => off()); // 清理监听器
});

// 监听暗黑模式变化来更新背景
watch(isDark, (newVal) => {
  if (scene) {
    // 这里的背景设置可以更复杂，例如使用不同的颜色或纹理
    // 为了简单起见，我们不直接设置背景色，让它保持透明
    // 你也可以通过 renderer.setClearColor 来设置
    if (newVal) {
      // renderer?.setClearColor(0x000000, 1);
    } else {
      // renderer?.setClearColor(0xffffff, 1);
    }
  }
}, { immediate: true });


// 过渡动画已简化，不再需要复杂状态


function copyEncryptedKeyPair() {
  if (encryptedPair.value) {
    navigator.clipboard.writeText(encryptedPair.value)
      .then(() => showToast(t('keyPairCopiedToClipboard'), 'success'))
      .catch(err => showToast(t('copyFailed'), 'error'));
  }
}

async function showEncryptedKeyPair() {
  if (showKeyPair.value) {
    showKeyPair.value = false;
    return;
  }
  showKeyPair.value = true;
  const userData = await storageServ.getUser(currentUserPub.value!);
  if (userData && userData.encryptedKeyPair) {
    encryptedPair.value = userData.encryptedKeyPair;
  } else {
    const encryptedKeyPair = await checkCredentials();
    if (encryptedKeyPair) {
      encryptedPair.value = encryptedKeyPair;
      showToast(t('keyPairLoadedFromCredentials'), 'success');
    } else {
      showToast(t('noEncryptedKeyPairFound'), 'warning');
    }
  }
}

async function checkCredentials() {
  const credentialsResult = await storageServ.query('SELECT value FROM credentials WHERE key = ?', ['userCredentials']);
  if (!credentialsResult.values || !credentialsResult.values.length) {
    return;
  }
  const encryptedCredentials = credentialsResult.values[0].value as string;
  const pair: any = JSON.parse(encryptedCredentials);
  if (!pair.pub || !pair.priv || !pair.epub || !pair.epriv) {
    return;
  }
  return pair;
}

function showPanel(content: PanelContentType) {
  panelContent.value = content;
  panelVisible.value = true;
}

function hidePanel() {
  panelVisible.value = false;
  panelContent.value = null;
  showDecryptedKeyPair.value = false;
  decryptedPair.value = '';
  decryptPassphrase.value = '';
  decryptMessage.value = '';
}

onMounted(async () => {
  positionState.value = 'middle';
  translateY.value = midPoint;
  cardsTranslateY.value = 0;
  if (currentUserPub.value) {
    const userData = await storageServ.getUser(currentUserPub.value);
    if (userData) {
      currentUserAlias.value = userData.alias || '';
      userAvatars.value[currentUserPub.value] = userData.avatar || '';
      encryptedPair.value = userData.encryptedKeyPair || '';
    }
    gun.get('users').get(currentUserPub.value).once((data: any) => {
      if (data?.alias) currentUserAlias.value = data.alias;
      if (data?.signature) currentUserAlias1.value = data.signature;
      if (data?.avatar) userAvatars.value[currentUserPub.value!] = data.avatar;
    });
  }
});

// 移除 cobe 相关的代码
</script>